"use strict";

exports.__esModule = true;
exports.OperatorPanelCollection = void 0;
var _API = require("../../../Components/API");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Provides access to operator panels via a render prop.
 */
var OperatorPanelCollection = exports.OperatorPanelCollection = function OperatorPanelCollection(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_API.Collection, {
    baseURL: "/api/v3/ui-config/operator-panels",
    itemBaseURL: "/api/v3/ui-config/operator-panels/:id"
  }, children);
};